import type { ComponentType } from "react";
import type { AdminAppToolDefinition } from "~/types";
import SunoIcon from "../icons/SunoIcon";
import YotoIcon from "../icons/YotoIcon";

import Badge from "@mui/icons-material/Badge";
import BarChart from "@mui/icons-material/BarChart";
import BugReport from "@mui/icons-material/BugReport";
import CloudSync from "@mui/icons-material/CloudSync";
import ConfirmationNumber from "@mui/icons-material/ConfirmationNumber";
import DesignServices from "@mui/icons-material/DesignServices";
import Email from "@mui/icons-material/Email";
import Flag from "@mui/icons-material/Flag";
import FolderOpen from "@mui/icons-material/FolderOpen";
import GitHub from "@mui/icons-material/GitHub";
import Group from "@mui/icons-material/Group";
import ModelTraining from "@mui/icons-material/ModelTraining";
import NotificationsActive from "@mui/icons-material/NotificationsActive";
import PlayArrow from "@mui/icons-material/PlayArrow";
import RssFeed from "@mui/icons-material/RssFeed";
import ScheduleSend from "@mui/icons-material/ScheduleSend";
import Settings from "@mui/icons-material/Settings";
import ShoppingCart from "@mui/icons-material/ShoppingCart";
import SmartToy from "@mui/icons-material/SmartToy";
import TextFields from "@mui/icons-material/TextFields";
import Work from "@mui/icons-material/Work";

export type AppToolType = AdminAppToolDefinition & {
  icon: ComponentType<any>;
  color:
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "info"
  | "error"
  | "yoto"
  | "transparent";
};

export const ADMIN_APP_TOOLS: AppToolType[] = [
  {
    id: "utilizatori",
    title: "Utilizatori",
    description: "Gestionează utilizatorii și conturile",
    icon: Group,
    href: "/admin/utilizatori",
    color: "primary",
  },
  {
    id: "comenzi",
    title: "Comenzi",
    description: "Gestionează comenzile și statusurile",
    icon: ShoppingCart,
    href: "/admin/comenzi",
    color: "success",
  },
  {
    id: "jobs",
    title: "Jobs",
    description: "Monitorizează și gestionează job-urile de fundal",
    icon: Work,
    href: "/admin/jobs",
    color: "warning",
  },
  {
    id: "analytics",
    title: "Analytics",
    description:
      "Vizualizează analiza traficului și comportamentul utilizatorilor",
    icon: BarChart,
    href: "/admin/analytics",
    color: "success",
  },
  {
    id: "blog",
    title: "Blog",
    description: "Gestionează articolele de blog și comentariile",
    icon: RssFeed,
    href: "/admin/blog",
    color: "secondary",
  },
  {
    id: "vouchere",
    title: "Vouchere",
    description: "Gestionează codurile de reducere și promoțiile",
    icon: ConfirmationNumber,
    href: "/admin/vouchere",
    color: "success",
  },
  {
    id: "newsletter",
    title: "Newsletter",
    description: "Gestionează abonații și campaniile de newsletter",
    icon: ScheduleSend,
    href: "/admin/newsletter",
    color: "info",
  },
  {
    id: "nume",
    title: "Validare Nume",
    description: "Gestionează cache-ul de validare a numelor",
    icon: Badge,
    href: "/admin/nume",
    color: "secondary",
  },
  {
    id: "rime",
    title: "Rime",
    description: "Descoperă rime pentru cuvinte românești cu analiza silabică",
    icon: TextFields,
    href: "/rime",
    color: "info",
  },
  {
    id: "llm",
    title: "LLM",
    description: "Vizualizează istoricul apelurilor către modelele de limbaj",
    icon: ModelTraining,
    href: "/admin/llm",
    color: "primary",
  },
  {
    id: "suno",
    title: "Suno",
    description: "Generează muzică cu AI și gestionează istoricul",
    icon: SunoIcon,
    href: "/admin/suno",
    color: "transparent",
  },
  {
    id: "copilot",
    title: "Copilot",
    description: "Vizualizează și interacționează cu sesiunile GitHub Copilot",
    icon: GitHub,
    href: "/admin/copilot",
    color: "info",
  },
  {
    id: "yoto",
    title: "Yoto",
    description:
      "Gestionează integrările Yoto Player și sincronizarea melodiilor",
    icon: YotoIcon,
    href: "/admin/yoto",
    color: "yoto",
  },
  {
    id: "email",
    title: "Email",
    description:
      "Gestionează emailurile trimise și previzualizează templateurile",
    icon: Email,
    href: "/admin/email",
    color: "error",
  },
  {
    id: "notificari",
    title: "Notificări",
    description:
      "Trimite notificări push utilizatorilor și vizualizează istoricul",
    icon: NotificationsActive,
    href: "/admin/notificari",
    color: "warning",
  },
  {
    id: "branding",
    title: "Branding",
    description: "Descarcă assets-urile de branding din folderul public",
    icon: DesignServices,
    href: "/admin/branding",
    color: "secondary",
  },
  {
    id: "imagini",
    title: "Imagini",
    description: "Vizualizează istoricul generărilor de imagini artwork",
    icon: SmartToy,
    href: "/admin/imagini",
    color: "secondary",
  },
  {
    id: "demos",
    title: "Demos",
    description: "Gestionează demo-urile și fișierele asociate",
    icon: PlayArrow,
    href: "/admin/demos",
    color: "primary",
  },
  {
    id: "stocare",
    title: "Stocare",
    description:
      "Explorează fișierele din bucketele de stocare și gestionează assets-urile",
    icon: FolderOpen,
    href: "/admin/stocare",
    color: "info",
  },
  {
    id: "problemeVersuri",
    title: "Versuri",
    description: "Răsfoiește fișierele de versuri, gestionează raportările și caută videoclipuri",
    icon: Flag,
    href: "/admin/versuri",
    color: "error",
  },
  {
    id: "configurari",
    title: "Configurări",
    description: "Editează valorile din kv store (configurații interne ale aplicației)",
    icon: Settings,
    href: "/admin/configurari",
    color: "secondary",
  },
  {
    id: "fundal",
    title: "Servicii Fundal",
    description: "Gestionează și rulează serviciile de fundal planificate",
    icon: CloudSync,
    href: "/admin/fundal",
    color: "warning",
  },
  {
    id: "loguri",
    title: "Loguri",
    description: "Vizualizează logurile serviciilor și erorile",
    icon: BugReport,
    href: "/admin/loguri",
    color: "error",
  },
];
